"use client"

import type React from "react"
import { memo } from "react"
import type { NavItem, User, UserMenuAction } from "../../../types/header"
import NavLink from "./NavLink"
import UserProfile from "./UserProfile"

interface DesktopNavigationProps {
  navItems: NavItem[]
  isAuthenticated: boolean
  user: User | null
  showUserMenu: boolean
  onToggleUserMenu: () => void
  userMenuActions: UserMenuAction[]
  userMenuRef: React.RefObject<HTMLDivElement | null> // Changed from RefObject<HTMLDivElement>
}

const DesktopNavigation: React.FC<DesktopNavigationProps> = memo(
  ({ navItems, isAuthenticated, user, showUserMenu, onToggleUserMenu, userMenuActions, userMenuRef }) => (
    <div className="desktop-nav">
      {navItems
        .filter((item) => {
          if (item.hideWhenAuth && isAuthenticated) return false
          if (item.requiresAuth && !isAuthenticated) return false
          return true
        })
        .map((item, index) => (
          <NavLink key={`${item.label}-${index}`} item={item} />
        ))}

      {isAuthenticated && user && (
        <UserProfile
          user={user}
          isMenuOpen={showUserMenu}
          onToggleMenu={onToggleUserMenu}
          menuActions={userMenuActions}
          menuRef={userMenuRef}
        />
      )}
    </div>
  ),
)

DesktopNavigation.displayName = "DesktopNavigation"

export default DesktopNavigation
